import { ImportReportDTO } from '../datasource/ImportReportDTO'

export class TranslateAndDateReportMapper {
  // eslint-disable-next-line class-methods-use-this
  map(report: ImportReportDTO) {
    return {
      ...report,
      id: report.id.toString(),
      translated_type: report.report.id_name === 'discounts' ? 'remises' : 'associations remise',
      imported_at: report.created_at,
      report: {
        ...report.report,
        line_errors: report.report.line_errors.map((error) => ({ ...error, line: error.line.toString() })),
        line_warnings: report.report.line_warnings?.map((warning) => ({ ...warning, line: warning.line.toString() })),
      },
    }
  }
}
